import { Link } from "react-router-dom";
import { MessageSquare, Phone } from "lucide-react";
import { PHONE_TEL, track } from "../lib/api";

export const MobileStickyBar = () => (
  <div
    data-testid="mobile-sticky-bar"
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-line bg-ink/95 backdrop-blur-xl pb-safe-bar md:hidden"
  >
    <a
      href={PHONE_TEL}
      data-testid="mobile-sticky-call-button"
      onClick={() => track("phone_click", { location: "mobile_sticky_bar" })}
      className="flex items-center justify-center gap-2 py-4 font-display text-base font-bold uppercase tracking-wider text-lime"
    >
      <Phone className="h-4 w-4" /> Call
    </a>
    <Link
      to="/contact"
      data-testid="mobile-sticky-request-button"
      className="flex items-center justify-center gap-2 bg-lime py-4 font-display text-sm font-bold uppercase tracking-wide text-ink"
    >
      <MessageSquare className="h-4 w-4" /> Request a Conversation
    </Link>
  </div>
);
